<template>
  <v-container grid-list-lg>
    <v-layout row wrap text-xs-center>
      <v-flex v-for="club in fichasList" :key="club.pk" md2>
        <v-card style="padding-top: 15px; min-height: 466px;" max-width="250">
          <v-img :src="club.logo" height="100px" contain></v-img>
          <v-card-text style="padding: 0 10px 0 10px;">
            <span class="subheading">{{ club.nombre }}</span>
            <div >
              <v-chip small v-for="category in club.tournamentCategories" :key="category.id">
                {{ category.description }}
              </v-chip>
            </div>
          </v-card-text>
          <v-divider style="margin-top: 10px;"></v-divider>
          <v-card-text>
            <div>Última actualización: </div>
            <div style="padding-bottom: 10px">{{ club.modified }}</div>
            <v-divider></v-divider>
            <v-btn style="margin-top: 20px;" class="search-button" dark fab depressed @click="goFicha(club.pk)"><v-icon>search</v-icon></v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      fichasList: []
    }
  },

  methods: {
    fetchData () {
      this.axios
        .get('ficha/clubes')
        .then(response => { this.fichasList = response.data })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    goFicha (id) {
      this.$store.dispatch('fetchFichaClub', id)
    }
  },

  mounted () {
    this.fetchData()
  }
}
</script>

<style scoped>
  span.subheading {
    display: inline-flex !important;
    height: 70px;
    align-items: center;
}
</style>
